import * as React from 'react';

const SvgClockSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M2.219 12.76c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.366 9.75-9.75 9.75-9.75-4.366-9.75-9.75m10.5-6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgClockSolid;
